export const SELFCARE_FLOOR_VIEW_IDS = [
  'SIMULATION_RECAP',
  'SOUSCRIPTION_PRICING'
];

const VIEWS_BEFORE_SIMULATION_RECAP = [
  'SIMULATION_EFFECT_DATE',
  'SIMULATION_COMPANY',
  'SIMULATION_DEMOGRAPHY',
  'SIMULATION_CUSTOMER_GRANTEES',
  'SIMULATION_NEEDS',
  'SIMULATION_PRODUCT',
  'SIMULATION_PRICINGS_INDIVIDUAL_HEALTH',
  'SIMULATION_PRICINGS_DAILY_BENEFIT',
  'SIMULATION_PRICINGS_SELF_WORKER',
  'SIMULATION_PRICINGS_GROUP_HEALTH',
  'SIMULATION_PAVILLON_INFORMATION'
];

const VIEWS_BEFORE_FLOOR = {
  SIMULATION_RECAP: VIEWS_BEFORE_SIMULATION_RECAP,
  SOUSCRIPTION_PRICING: [...VIEWS_BEFORE_SIMULATION_RECAP, 'SIMULATION_RECAP']
};

export const isViewBeforeSelfcareFloor = (viewId, floorViewId) =>
  (VIEWS_BEFORE_FLOOR[floorViewId] ?? []).includes(viewId);

export const isSelfcareFloorView = (viewId, floorViewId) =>
  SELFCARE_FLOOR_VIEW_IDS.includes(floorViewId) && viewId === floorViewId;
